import { render, staticRenderFns } from "./privacy2.1.vue?vue&type=template&id=7f102b62&scoped=true&"
import script from "./privacy2.1.vue?vue&type=script&lang=js&"
export * from "./privacy2.1.vue?vue&type=script&lang=js&"
import style0 from "./privacy2.1.vue?vue&type=style&index=0&id=7f102b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f102b62",
  null
  
)

export default component.exports